import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

const rootElement = document.getElementById("root");

// 使用 hydrateRoot 以支持 react-snap 预渲染
// 如果页面已经有预渲染的内容，React 会复用它
if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(
    rootElement,
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  // 如果没有预渲染内容（比如在开发模式），使用正常的 render
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

// Web-vitals reporting can be connected to an analytics endpoint when needed.
reportWebVitals();
